/**
 * Rocksoft Places API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const OperationFlags = {
    None: 'None',
    Create: 'Create',
    Read: 'Read',
    Update: 'Update',
    Delete: 'Delete',
} as const;
export type OperationFlags = typeof OperationFlags[keyof typeof OperationFlags];

